<template>
  <div class="body">
    <PersonalHeader></PersonalHeader>
    <main class="main">
      <div class="caption flex">
        <div class="caption-greetings">
          <h1 class="caption-greetings__title">Практикум</h1>
        </div>
        <PersoneInCaption></PersoneInCaption>
      </div>
      <div class="filling mt-40 flex">
        <div class="content flex flex-dir-col">
          <div class="list">
            <div class="list-fill">
              <SeparateRecommendedLessonTest
                v-for="item in testingsList"
                :key="item.id"
                :testing="item">
              </SeparateRecommendedLessonTest>
            </div>
            <button
              class="more content-more btn-midle br-red m0-auto mt-30 red"
              @click="loadMoreTestings"
              v-if="paginationParams.canLoadMore">
              Еще
            </button>
          </div>
        </div>
      </div>
    </main>
    <PersonalProfile></PersonalProfile>
  </div>
</template>

<script setup>
import PersonalHeader from "../../components/personal_area/PersonalHeader.vue";
import PersonalProfile from "../../components/personal_area/PersonalProfile.vue";
import PersoneInCaption from "../../components/personal_area/PersoneInCaption.vue";
import SeparateRecommendedLessonTest from "../../components/tests/SeparateRecommendedLessonTest.vue";
import {useStore} from "vuex";
import {computed, onUnmounted, reactive, ref} from "vue";

const store = useStore();

const isLoadingProcess = ref(false);

const testingsList = computed(() => store.getters.testingsList);

const paginationParams = reactive({
  page: 1,
  limit: 5,
  canLoadMore: true,
});

async function fetchTestingsList() {
  if (isLoadingProcess.value) return;

  isLoadingProcess.value = true;

  try {
    const resultsCount = await store.dispatch(
      "fetchTestingsList",
      paginationParams
    );
    if (resultsCount !== paginationParams.limit) {
      paginationParams.canLoadMore = false;
    }
  } catch (e) {
    console.log(e);
  } finally {
    isLoadingProcess.value = false;
  }
}

function loadMoreTestings() {
  if (!paginationParams.canLoadMore) return;
  paginationParams.page++;
  fetchTestingsList();
}

fetchTestingsList();

onUnmounted(() => {
  store.commit("clearTestingList");
});
</script>

<style scoped>
.body {
  display: flex;
}

.main {
  margin: 0 60px 56px 40px;
  width: 100%;
}

.blocked-btn {
  opacity: 0.3;
  pointer-events: none;
}

/* Caption */

.caption {
  padding: 40px 0px 0px 0px;
  align-items: flex-start;
}

.caption-greetings__title {
  font-family: "PT";
  font-weight: 700;
  font-size: 48px;
  line-height: 1.2;
  max-width: 782px;
}

/* filling */
.filling {
  max-width: 100%;
  width: 100%;
  align-items: flex-start;
}

.content {
  width: 100%;
}

.list {
  background: #ffffff;
  border: 1px solid rgba(85, 85, 85, 0.2);
  border-radius: 10px;
  box-shadow: 0px 40px 140px rgba(0, 0, 0, 0.06);
  padding: 20px 10px;
}
.list-fill {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 20px;
}
@media (max-width: 2600px) {
  .list-fill {
    grid-template-columns: repeat(7, 1fr);
  }
}
@media (max-width: 2300px) {
  .list-fill {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (max-width: 1930px) {
  .list-fill {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (max-width: 1730px) {
  .list-fill {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 1400px) {
  .list-fill {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 900px) {
  .list-fill {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .list-fill {
    grid-template-columns: repeat(1, 1fr);
  }
}
.list-fill:deep(.separate-test) {
  max-width: 100%;
}
.more {
  margin: 20px auto 0 auto;
}

@media (max-width: 1300px) {
  .main {
    margin-left: 20px;
  }

  /* Caption */
  .caption {
    padding: 40px 0px 30px 0px;
    justify-content: space-between;
  }

  .caption-greetings__title {
    font-size: 24px;
  }

  .content {
    margin-right: 20px;
  }
}

@media (max-width: 950px) {
  .content {
    margin-right: 0px;
  }

  .content {
    margin-top: 0;
  }

  .body {
    flex-direction: column;
  }

  .filling {
    flex-direction: column;
  }

  .caption {
    padding: 40px 0 0 0;
  }

  .caption-greetings__title {
    font-size: 32px;
  }

  .main {
    margin-left: 0;
    margin-right: 0;
    padding: 0 20px;
  }
}

@media (max-width: 600px) {
  .main {
    padding: 0 10px;
  }

  .filling {
    margin-top: 30px;
  }

  .caption-greetings {
    max-width: 100%;
    width: 100%;
  }

  .caption-greetings__title {
    text-align: center;
    font-size: 24px;
    max-width: 100%;
  }
}
</style>
